import { combineActions, handleActions } from 'redux-actions';

import { settingsVerificationUpdateSuccess } from '../../ProfileVerification/actions';
import {
  confirmQuestionnaireSuccess,
  saveQuestionnaireAnswersSuccess,
} from 'modules/cySecQuestionnaire/actions';
import {
  acceptTradeWithRestrictionsSuccess,
  cySecVerificationPageOpened,
  cySecVerificationSecondStepUpdateSuccess,
  cySecVerificationUpdateSuccess,
  getVerificationUserSuccess,
  updatePersonalDetailsSuccess,
} from '../actions';

const defaultState = {};

export default handleActions(
  {
    [cySecVerificationPageOpened]() {
      return { ...defaultState };
    },
    [combineActions(
      getVerificationUserSuccess,
      updatePersonalDetailsSuccess,
      cySecVerificationUpdateSuccess,
      cySecVerificationSecondStepUpdateSuccess,
      confirmQuestionnaireSuccess,
      settingsVerificationUpdateSuccess,
    )](state, action) {
      return { ...action.response.data };
    },
    [combineActions(saveQuestionnaireAnswersSuccess, acceptTradeWithRestrictionsSuccess)](
      state,
      action,
    ) {
      return { ...action.response.data.user };
    },
    [getVerificationUserSuccess]: (state, action) => {
      return { ...state, applicationLog: action.response.data };
    },
  },
  defaultState,
);
